// import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faGithub } from "@fortawesome/free-brands-svg-icons";
import RiskyJumperIcon from "./assets/riskyJumperIcon.png";
import RiskyJumperWeb3Icon from "./assets/riskyJumperWeb3Icon.png";
import CircleRiskIcon from "./assets/circleRiskIcon.png";
import ComplexityJungleIcon from "./assets/complexityJungleIcon.png";
import ManualSwampIcon from "./assets/manualSwampIcon.png";
import ScalabilityMountainIcon from "./assets/scalabilityMountainIcon.png";
import MathRaceIcon from "./assets/mathRaceIcon.png";
import VocabularyRaceIcon from "./assets/vocabularyRaceIcon.png";
import SlotMachineIcon from "./assets/slotMachineIcon.png";
import MoonionsIcon from "./assets/moonionsIcon.png";
import MathFishIcon from "./assets/mathFish.png";
import CoffeeMachineIcon from "./assets/coffeeMachine.png";
import GolfIcon from "./assets/golfIcon.png";
import DiceGameIcon from "./assets/diceGame.png";
import CarnivalDartsIcon from "./assets/carnavalDartsIcon.png";
import BottleFlipIcon from "./assets/bottleFlipIcon.png";
import JumpDinoIcon from "./assets/jumpDinoIcon.png";
import PlinkoIcon from "./assets/plinkoIcon.png";
import "./Games.css";

// const gitHubURL = "https://www.github.com/PrzemoProgrammer";
const riskyJumperAppStoreLink =
  "https://play.google.com/store/apps/details?id=com.riskyjumper.app";
const circleRiskAppStoreLink =
  "https://play.google.com/store/apps/details?id=com.pipcompany.circlerisk";
const moonionsURL = "https://twitter.com/_moonions";
const slotMachineURL = "https://przemoprogrammer.github.io/Slot-Machine/"; //"https://github.com/PrzemoProgrammer/Slot-Machine";
const fishGameURL = "https://przemoprogrammer.github.io/fishMathGame/";
const coffeeMachineGameURL = "https://przemoprogrammer.github.io/Coffe-Game/";
const diceGameURL = "https://przemoprogrammer.github.io/Dice-Game/";
const correctVocabularyGameURL =
  "https://przemoprogrammer.github.io/Correct-Vocabulary-Game/";
const webRiskyJumperURL =
  "https://przemoprogrammer.github.io/Web-Risky-Jumper/";
const webCircleRiskURL = "https://siderprogrammer.github.io/CircleRiskWeb/";
const web3RiskyJumperURL =
  "https://przemoprogrammer.github.io/Web3-Risky-Jumper/";
const golfGameURL = "https://przemoprogrammer.github.io/Golf-Educational-Game/";
const carnivalGameURL = "https://przemoprogrammer.github.io/Carnaval-Game/";
const manualSwampURL = "https://przemoprogrammer.github.io/ManualSwamp/";
const scalabilityMountainURL =
  "https://przemoprogrammer.github.io/Scalability-Mountain/";
const mathCarRaceURL = "https://przemoprogrammer.github.io/Math-Car-Race-Game/";
const bottleFlipURL = "https://przemoprogrammer.github.io/Bottle-Flip-Game/";
const dinoJumperURL = "https://przemoprogrammer.github.io/Dino-Jumper-Game/";
const mazeGameURL = "https://przemoprogrammer.github.io/Maze-Game/";
const plinkoGameURL = "https://przemoprogrammer.github.io/Plinko-Game/";

function AddGame({ type, link, icon, title, description, onClick }) {
  const handleClick = typeof onClick === "function" ? onClick : () => {};
  const linkProps = link && link !== "none" ? { to: link } : {};
  return (
    <Link className="link" {...linkProps}>
      <div className={type} onClick={handleClick}>
        <img className="game-icon" src={icon} alt={title} />
        <h1 className="game-title">{title}</h1>
        {/* <h3 className="description">{description}</h3> */}
      </div>
    </Link>
  );
}

function GamesPage() {
  return (
    <div className="games-page" id="games">
      <div className="games-list">
        {/* <h1 className="page-title">Games</h1> */}
        <div className="browser">
          <h1 className="browser-title">Games For Browser</h1>

          <div className="games-container">
            <AddGame
              type="web-game"
              link="none"
              icon={RiskyJumperIcon}
              title="Risky Jumper"
              description="Simple one tap game with ranking online"
              onClick={() => window.open(webRiskyJumperURL, "_blank")}
            />

            <AddGame
              type="web-game"
              link="none"
              icon={CircleRiskIcon}
              title="Circle Risk"
              description="Simple one tap game with ranking online"
              onClick={() => window.open(webCircleRiskURL, "_blank")}
            />

            <AddGame
              type="web-game"
              link="none"
              icon={SlotMachineIcon}
              title="Slot Machine"
              description="Arrange the symbols in the correct configuration and win"
              onClick={() => window.open(slotMachineURL, "_blank")}
            />

            <AddGame
              type="web-game"
              link="none"
              icon={GolfIcon}
              title="Golf"
              description=""
              onClick={() => window.open(golfGameURL, "_blank")}
            />

            <AddGame
              type="web-game"
              link="none"
              icon={RiskyJumperWeb3Icon}
              title="Risky Jumper ETH"
              description=""
              onClick={() => window.open(web3RiskyJumperURL, "_blank")}
            />

            <AddGame
              type="web-game"
              link="none"
              icon={PlinkoIcon}
              title="Plinko"
              description="In the process of making..."
              onClick={() => window.open(plinkoGameURL, "_blank")}
            />

            <AddGame
              type="web-game"
              link="none"
              icon={BottleFlipIcon}
              title="Bottle Flip"
              description="In the process of making..."
              onClick={() => window.open(bottleFlipURL, "_blank")}
            />

            <AddGame
              type="web-game"
              link="none"
              icon={MoonionsIcon}
              title="Moonions"
              description="In the process of making..."
              onClick={() => window.open(moonionsURL, "_blank")}
            />

            <AddGame
              type="web-game"
              link="none"
              icon={MathFishIcon}
              title="Fisher Math"
              description="Answer the question correctly by shooting the fish"
              onClick={() => window.open(fishGameURL, "_blank")}
            />

            <AddGame
              type="web-game"
              link="none"
              icon={ComplexityJungleIcon}
              title="Complexity Jungle"
              description="You have 60 seconds to get out of the maze without getting killed"
              onClick={() => window.open(mazeGameURL, "_blank")}
            />

            <AddGame
              type="web-game"
              link="none"
              icon={ScalabilityMountainIcon}
              title="Scalability Mountain"
              description="You have 90 seconds to get to the top of the mountain as quickly as possible"
              onClick={() => window.open(scalabilityMountainURL, "_blank")}
            />

            <AddGame
              type="web-game"
              link="none"
              icon={ManualSwampIcon}
              title="Manual Swamp"
              description="You have to last 60 seconds jumping over garbage"
              onClick={() => window.open(manualSwampURL, "_blank")}
            />

            <AddGame
              type="web-game"
              link="none" ///CorrectVocabulary
              icon={VocabularyRaceIcon}
              title="Vocabulary Race"
              description="Choose the correct spelling of the word and win the race"
              onClick={() => window.open(correctVocabularyGameURL, "_blank")}
            />

            <AddGame
              type="web-game"
              link="none"
              icon={MathRaceIcon}
              title="Math Race"
              description="Answer math correctly and overtake cars to earn points"
              onClick={() => window.open(mathCarRaceURL, "_blank")}
            />

            <AddGame
              type="web-game"
              link="none"
              icon={JumpDinoIcon}
              title="T-Rex Runner"
              description="Test your luck of winning with the coffee machine"
              onClick={() => window.open(dinoJumperURL, "_blank")}
            />

            <AddGame
              type="web-game"
              link="none"
              icon={CoffeeMachineIcon}
              title="Coffee Machine"
              description="Test your luck of winning with the coffee machine"
              onClick={() => window.open(coffeeMachineGameURL, "_blank")}
            />

            <AddGame
              type="web-game"
              link="none"
              icon={DiceGameIcon}
              title="Lucky Dice"
              description="Test your luck of winning with the dice"
              onClick={() => window.open(diceGameURL, "_blank")}
            />

            <AddGame
              type="web-game"
              link="none"
              icon={CarnivalDartsIcon}
              title="Carnival Darts"
              description="Test your luck of winning with the dice"
              onClick={() => window.open(carnivalGameURL, "_blank")}
            />
          </div>
        </div>

        <div className="android">
          <h1 className="android-title">Games For Android</h1>
          <div className="games-container">
            <AddGame
              type="android-game"
              link="none"
              icon={RiskyJumperIcon}
              title="Risky Jumper"
              description="Simple one tap game with ranking online"
              onClick={() => window.open(riskyJumperAppStoreLink, "_blank")}
            />

            <AddGame
              type="android-game"
              link="none"
              icon={CircleRiskIcon}
              title="Circle Risk"
              description="Simple one tap game with ranking online"
              onClick={() => window.open(circleRiskAppStoreLink, "_blank")}
            />
          </div>
        </div>
        {/* <h1 className="page-title">Games source code</h1>
        <div className="icon">
          <a href={gitHubURL} target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faGithub} />
          </a>
        </div> */}
      </div>
    </div>
  );
}

export default GamesPage;
